import { TopSection } from "src/components/_pages/accomodation-contract/top-section";
import { TextSection } from "src/components/_pages/accomodation-contract/text-section";
import { Footer } from "src/components/footer";

const AccomodationContract = () => {
  return (
    <>
      <title>石巻マリンヴィレッジ | ACCOMODATION CONTRACT</title>
      <article>
        <TopSection />
        <TextSection />
        <Footer />
      </article>
    </>
  );
};

export default AccomodationContract;
